import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

export const selectRentalsById = (state: RootState) =>
  state.data.rentals.entities;
const selectIds = (state: RootState) => state.data.rentals.ids;

export const selectRentals = createSelector(
  selectIds,
  selectRentalsById,
  (ids, entities) => ids.map((id) => entities[id])
);

export const selectRental = (id?: string | null) => (state: RootState) =>
  !id ? undefined : state.data.rentals.entities[id];

export const selectRentalsLoading = (state: RootState) =>
  state.data.rentals.loading;
